import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function Inbox() {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get("https://ma-laravel.ma-uae.com/api/contact-us");
      console.log("Full response:", response);        // هنا نشوف كل response
      console.log("Data from API:", response.data);   // هنا نشوف response.data

      // المصفوفة الفعلية موجودة في response.data.data
      if (response.data && Array.isArray(response.data.data)) {
        setMessages(response.data.data);
      } else {
        console.warn("Data is not an array or missing:", response.data);
        setMessages([]);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Unexpected data format received from the server.",
        });
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      setMessages([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch messages. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will delete the message permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Close",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://ma-laravel.ma-uae.com/api/contact-us/${id}`);
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Message deleted successfully!",
        });
        fetchMessages();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete message. Please try again.",
        });
      }
    }
  };

  return (
    <section className="p-6">
      <h1 className="text-2xl font-bold mb-4">Inbox</h1>

      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 p-2">Full Name</th>
            <th className="border border-gray-300 p-2">Email</th>
            <th className="border border-gray-300 p-2">Phone</th>
            <th className="border border-gray-300 p-2">Company</th>
            <th className="border border-gray-300 p-2">Service</th>
            <th className="border border-gray-300 p-2">Message</th>
            <th className="border border-gray-300 p-2">Date</th>
            <th className="border border-gray-300 p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="8" className="border border-gray-300 p-2 text-center">
                Loading...
              </td>
            </tr>
          ) : messages.length > 0 ? (
            messages.map((message) => (
              <tr key={message.id}>
                <td className="border border-gray-300 p-2">
                  {message.full_name}
                </td>
                <td className="border border-gray-300 p-2">{message.email}</td>
                <td className="border border-gray-300 p-2">{message.phone}</td>
                <td className="border border-gray-300 p-2">{message.company}</td>
                <td className="border border-gray-300 p-2">{message.service}</td>
                <td className="border border-gray-300 p-2">{message.message}</td>
                <td className="border border-gray-300 p-2">
                  {new Date(message.created_at).toLocaleDateString()}
                </td>
                <td className="border border-gray-300 p-2">
                  <button
                    className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                    onClick={() => handleDelete(message.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="border border-gray-300 p-2 text-center">
                No messages available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}